// SPDX-License-Identifier: GPL-3.0-or-later
// Entry point of the game page bundle (public/assets/main.js).

import { bootGamePage } from "./game-page.ts";

bootGamePage(document, window);
